import menu_burger from '../assets/menu_burger.svg'
import { useState, useEffect } from "react";

const BREAKPOINT = 1015;
const Header = ({onToggle}) => {
  const token = Date.now();
  const raw = `tenant=sagishutrit&ts=${token}`;
  const encoded = btoa(raw);
  const viewingroom_Address = `https://sagishutrit.viewingrooms.nl/?tenant=unkownt&access_token=${encoded}`;
  const size = useWindowSize();
  const d = document.querySelectorAll(".mitgar")
  const [isOpen, setIsOpen] = useState(false)
  const burger = () => {
    const newState = !isOpen;
    setIsOpen(newState); // Updates local state for the X animation
    console.log("Will pass up toparent component");
    onToggle(newState);
  };
  const headertop = document.getElementById('nomo12');
  const tmuna = document.querySelectorAll(".tmuna");
  if (window.innerWidth < BREAKPOINT) {
     headertop.style.display = 'none'
    if (headertop) {
      headertop.classList.add('mobi')
    }

  }
  if (window.innerWidth > BREAKPOINT) {
    headertop.style.display = 'block';

    if (d && d[0]) {
      if (d[0].classList.contains('mob-menu')) {
        d[0].classList.remove('mob-menu')
      }
    }
    if(tmuna && tmuna[0]) {
      tmuna[0].classList.remove("mob");
    }
  }
  if (window.innerWidth > BREAKPOINT) {
    return (<div className="side-nav">
      <div className='header-top'>
        <h1 style={{  margin:'0' }}><a href="/">SAGI SHUTRIT</a></h1>
      </div>
      <div className='top'>
        <img onClick={burger} src={menu_burger} alt='menu' />
        <ul className="nav tablet-sm">
          <li><a id="drawings" href="drawings">Drawings</a></li>
          <li><a id="paintings" href="paintings">Paintings</a></li>
          <li><a id="contact" href="contact">Contact</a></li>
          <li><a id="viewingroom" href={viewingroom_Address}>Viewing room</a></li>
        </ul>
      </div>
    </div>);
  }

  return((<div className="side-nav" style={{ width: '100%', position: 'relative' }}>
  <div className='header-mob-top' style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    padding: '20px',
    position: 'relative',
    zIndex: 1001 
  }}>
    <h1 style={{ margin: '0', fontSize: '1.5rem' }}>
      <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>SAGI SHUTRIT</a>
    </h1>
    <div onClick={burger} style={{ 
      cursor: 'pointer', 
      width: '30px', 
      height: '21px', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'space-between' 
    }}>
      {/* Top Bar */}
      <span style={{ 
        width: '100%', height: '3px', backgroundColor: 'black', transition: '0.3s',
        transform: isOpen ? 'rotate(45deg) translate(6px, 6px)' : 'none' 
      }}></span>
      {/* Middle Bar */}
      <span style={{ 
        width: '100%', height: '3px', backgroundColor: 'black', transition: '0.3s',
        opacity: isOpen ? 0 : 1 
      }}></span>
      {/* Bottom Bar */}
      <span style={{ 
        width: '100%', height: '3px', backgroundColor: 'black', transition: '0.3s',
        transform: isOpen ? 'rotate(-45deg) translate(6px, -7px)' : 'none' 
      }}></span>
      </div>
      
  </div>

  {/* THE OVERLAY: Controlled by your state variable */}
  <div className='mobnar' style={{      
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'white',
    overflow:'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0)',
    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
    zIndex: 1000,
    visibility: isOpen ? 'visible' : 'hidden'
  }}>      
    <ul className="" style={{ listStyle: 'none', textAlign: 'center', padding: 0 }}>
        <li><a id="drawings" href="drawings" style={{ fontSize: '2rem', textDecoration: 'none', color: 'black' }}>Drawings</a></li>
        <li style={{ margin: '20px 0' }}><a id="paintings" href="paintings" style={{ fontSize: '2rem', textDecoration: 'none', color: 'black' }}>Paintings</a></li>
        <li style={{ margin: '20px 0' }}><a id="viewingroom" href={viewingroom_Address} style={{ fontSize: '2rem', textDecoration: 'none', color: 'black' }}>Viewing room</a></li>
        <li style={{ margin: '20px 0' }}><a id="contact" href="contact" style={{ fontSize: '2rem', textDecoration: 'none', color: 'black' }}>Contact</a></li>
      </ul>     
    </div>
</div>));
}
// Hook
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {

    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
export default Header